export default "__VITE_ASSET__DZeKFbhQ__";